import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import {
  AboveTheFoldSection,
  BrandEndorsementsSection,
  EndlessVarietySection,
  CustomerReviewsSection,
  HowItWorksSection,
  OurSuppliersSection,
  ValueYouCanTasteSection,
} from '@library/landing-pages'
import type { Recipe } from '@library/menu-service'

export type HomepageProps = {
  onSignupCTAClick: () => void
  signupCTA: string
  recipes: Recipe[]
}

export function Homepage({ signupCTA, onSignupCTAClick, recipes }: HomepageProps) {
  return (
    <Box data-testid="homepage">
      <AboveTheFoldSection onCTAClick={onSignupCTAClick} signupCTA={signupCTA} />
      <CustomerReviewsSection />
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <ValueYouCanTasteSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <EndlessVarietySection
        signupCTA={signupCTA}
        onCTAClick={onSignupCTAClick}
        recipes={recipes}
      />
      <BrandEndorsementsSection />
      <OurSuppliersSection />
    </Box>
  )
}
